import React from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { useApiListTradeshow } from '../../../../../api-new/state/content'
import { Menu, MenuPurge, MenuRestore } from '../../../../../shared/menu/menu'
import { useRoleOrgTradeshow } from '../../../../../role/hook/role-org'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

export function TradeshowRecycle() {
  const apiListTradeshow = useApiListTradeshow()

  const roleOrgTradeshow = useRoleOrgTradeshow()

  const [error, failure, setError] = useErrorLine()

  const handleReady = async () => await apiListTradeshow.get('deleted')
  const handleDestroyed = () => apiListTradeshow.init()

  const handleRestore = async tradeshow => {
    setError(null)
    try {
      await apiListTradeshow.put(`${tradeshow.id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That tradeshow was already removed.'), err)
    }
    await apiListTradeshow.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListTradeshow} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row)} show={roleOrgTradeshow.accessDelete} pin />
                  <MenuPurge to={`/org/tradeshow/list/recycle/purge/${row.id}`} show={roleOrgTradeshow.accessPurge} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
